import { useState } from "react";
import { NotebookPen } from "lucide-react";

import { Button } from "@/components/ui/button";
import type { ApplicationNotesDict } from "@/types/borrower";
import { NotesDialog } from "./NotesDialog";

interface NotesButtonProps {
  borrowerId: number;
  notes: ApplicationNotesDict | undefined;
  disabled?: boolean;
  className?: string;
}

/** The application's Notes button and its dialog. */
export function NotesButton({ borrowerId, notes, disabled, className }: NotesButtonProps) {
  const [open, setOpen] = useState(false);
  const count = Object.values(notes ?? {}).reduce((sum, user) => sum + user.notes.length, 0);
  const label = count > 0 ? `Notes (${count})` : "Add Notes";

  return (
    <>
      <NotesTrigger
        label={label}
        onClick={() => setOpen(true)}
        disabled={disabled}
        className={className}
      />
      <NotesDialog
        open={open}
        onClose={() => setOpen(false)}
        borrowerId={borrowerId}
        notes={notes ?? {}}
      />
    </>
  );
}

/** Holds the Notes button's place, styled the same, while the application loads. */
export function NotesButtonPlaceholder() {
  return <NotesTrigger label="Notes" disabled />;
}

interface NotesTriggerProps {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

function NotesTrigger({ label, onClick, disabled, className }: NotesTriggerProps) {
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={className}
      onClick={onClick}
      disabled={disabled}
    >
      <NotebookPen className="h-4 w-4" />
      {label}
    </Button>
  );
}
